import React from "react";
import YouTube from 'react-youtube';

import Header from '../../header';
import Footer from '../../footer';
import ApplicationFormSummer from '../../components/forms/ApplicationFormSummer';
import LoadingSpinner from '../../components/spinner/LoadingSpinner';

import {getCampArticles, getCampIntroduction, loadCampsDataAndRender} from './CampsUtil';

export default class SummerCamps extends React.Component {

  constructor(props) {
   super(props);
    this.state = {
      photoUrl: undefined,
      campsData: [],
      photoGallery: [],
      promoPhotos:[],
      isLoading: true
    };
  }

  componentDidMount(){
      loadCampsDataAndRender("summer_camps", this);
  }

  render() {
    const {campsData, isLoading, isIntroLoading, photoUrl, promoPhotos, photoGallery} = this.state;
    const hideHeaderAndFooter = this.props.hideHeaderAndFooter;
    let campIntroduction = undefined;
    let isPhotoGalleryLoading = true;
    let isPromoLoading = true;

    if(campsData.length > 0) {
      campIntroduction = campsData[0];

      // photo galleries
      let numberOfGalleriesToLoad = campIntroduction.number_of_galleries !== undefined ? campIntroduction.number_of_galleries : 0;
      isPhotoGalleryLoading = (photoGallery.length < numberOfGalleriesToLoad);
      console.log("Number of photoGallery to load: " + numberOfGalleriesToLoad);
      console.log("Loaded photoGalleries: " + photoGallery.length);

      //promo photos
      let numberOfPromosToLoad = campIntroduction.number_of_promo_photos !== undefined ? campIntroduction.number_of_promo_photos : 0;
      isPromoLoading = (promoPhotos.length < numberOfPromosToLoad);
      console.log("Number of promo ohotos to load: " + numberOfPromosToLoad);
      console.log("Loaded promo photos: " + promoPhotos.length);
    }

    const opts = {
     height: '430',
     width: '100%',
     playerVars: { // https://developers.google.com/youtube/player_parameters
       autoplay: 0
     }
    };

    let loading = isLoading || isIntroLoading || isPhotoGalleryLoading || isPromoLoading

    return loading ? (
            <LoadingSpinner loadingState={loading} />
        ) : (
      <div>
           {hideHeaderAndFooter ? '' : <Header />}
           <div className="view textArticle camps">


              {getCampIntroduction(campsData[0], photoUrl, promoPhotos)}
              <h4> Brankářské kempy 2026: Polovina už je pryč. Kdo zaváhá, nechytá. </h4>
              <br/>
              <p>
              <h5>
                ❌ Libice nad Doubravou (12. 7. – 17. 7. | 19. 7. – 24. 7.) – PLNO
              </h5>
              Kapacita praskla ve švech. Pokud jsi to nestihl, netruchli. Pořád máš dvě šance, jak do toho v létě šlápnout. Ale mizí to.
              </p>

              <p>
              <h5>
                ⛺ 3. 8. – 7. 8. | <a href='https://just4keepers.dtap.cz/register/?link=20'>Kobylí na Moravě: Klasika se vším všudy</a>
              </h5>
              Pět dní, kdy tvoje jediná starost bude, jak si užít chytání naplno. Tohle je poctivý pobytový kemp se spaním. Ráno vstaneš, navlékneš rukavice, směješ se a posouváš. Večer jdeš do postele s pocitem, že jsi pro sebe udělal(a) maximum. A s partou stejných bláznů do chytání to jde vždycky lépe.
              <br/>
              <b>Cena: 6650,- </b>
              </p>

              <p>
              <h5>
                ⚽ 27. 7. – 31. 7. | <a href='https://just4keepers.dtap.cz/register/?link=20'>Bosonohy: příměstský kempy</a>
              </h5>
              Ideální kompromis. Přes den makáš na hřišti, piluješ techniku chytání a večer už regeneruješ ve vlastní posteli.

              Tenhle kemp jsme navíc otevřeli <b>i pro hráče a hráčky</b> z pole (specificky ročníky <b>2014–2016</b>). Co to pro vás znamená? Reálné herní situace a pořádná prověrka, ne jen střelba do prázdné brány a nebo kopy ze statických pozic. Bude to mít zápasové grády.
              <br/>
              <b>Cena: 4200,-</b>
              </p>

              <p>
                <a href='https://just4keepers.dtap.cz/register/?link=20'>ONLINE PŘIHLÁŠKA</a>
              </p>
              <p>
              <b>Holky vítány. A rovnou říkáme – je to vaše výhoda.</b>

              Všechny naše kempy jsou otevřené pro kluky i holky. A pro holky je to mimochodem obrovská zbraň. Trénink v ryze klučičím, konkurenčním prostředí tě připraví na tvrdší rány, vyšší rychlost. Až se pak vrátíš do své soutěže, budeš z toho čerpat a mít větší pocit jistoty.
              </p>

              <p>
                <b>Vše potřebné se dozvíte na této stránce. Za letní kempy poprosíme o platbu na účet: 90949622/5500.</b>
                <br/>
                <a href='/#/payment-conditions'>Platební a storno podmínky</a>
              </p>


               <div>

                   {getCampArticles(campsData, photoGallery)}

                   <div className="responsive left">
                     {
                       campIntroduction.videoYoutubeIds.map((videoId, index) => (
                          <div className={"column-" + ((index % 3 ) + 1) }>
                           <YouTube
                             videoId={videoId}
                             opts={opts}
                             onReady={this._onReady}
                             />
                         </div>
                       ))
                      }
                   </div>

               </div>
           </div>

            {hideHeaderAndFooter ? '' : <Footer />}
      </div>

    );
  }
}
